export const dropdownRequiredErrorMessage = "Please select an option";
export const inputFormatErrorMessage = "Invalid entry, please use only letters and numbers";
export const onlyDigitsError = "Invalid entry, please use digits only";
export const businessUnitErrorMessage = "Based on selected application within CRM";
export const marketSegmentErrorMessage = "Based on selected application within CRM";
export const applicationFieldErrorMessage =
  "Please add the application to the opportunity in CRM. The values will transfers to the LEAP request afterwards";
